{
  "pt_BR": "viagem-solo",
  "cs_CZ": "solo-cestovani",
  "da_DK": "solo-rejse",
  "de_DE": "solo-reisen",
  "en_GB": "solo-travel",
  "es_ES": "viaje-solo",
  "fi_FI": "yksin-matkustaminen",
  "fr_FR": "voyage-solo",
  "it_IT": "viaggio-solo",
  "ja_JP": "soro-toraberu",
  "ko_KR": "honja-yeohaeng",
  "nl_NL": "solo-reizen",
  "nb_NO": "solo-reise",
  "pl_PL": "podroz-solo",
  "pt_PT": "viagem-solo",
  "ru_RU": "odinochnye-puteshestviya",
  "sv_SE": "solo-resa",
  "tr_TR": "solo-gezi",
  "zh_CN": "du-chu-lu-xing"
}
